export enum TOKEN_TYPE {
    CLIENT = 'client_token',
    EXTERNAL = 'session',
    MANAGER = 'auth_token',
}
